import { api, VAULT_API_SUB_URLS, V2 } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import { RootState } from '@/@types/member';
import { VaultDataResponseModel } from '@/@types/member';

interface VaultState {
  unsubmittedDocuments: VaultDataResponseModel[];
  submittedDocuments: VaultDataResponseModel[];
}

const VAULT_STATE: Module<VaultState, RootState> = {
  state: {
    unsubmittedDocuments: [],
    submittedDocuments: [],
  },
  actions: {
    // UC-REST-027 - Get Vault Data
    getVaultData(context): Promise<AxiosResponse> {
      return api
        .get(
          `${VAULT_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/vault-data${V2}`,
        )
        .then((vaultData) => {
          if (vaultData && vaultData.data) {
            context.commit('setVaultData', vaultData.data);
            return vaultData.data;
          }

          context.commit('setVaultData', []);
          return [];
        });
    },
  },
  mutations: {
    setVaultData(state: VaultState, data: VaultDataResponseModel[]) {
      state.unsubmittedDocuments = data.filter((document) => {
        return !document.isSubmitted && !document.isMatched;
      });
      state.submittedDocuments = data.filter((document) => {
        return document.isSubmitted || document.isMatched;
      });
    },
  },
  getters: {
    unsubmittedDocuments(state): VaultDataResponseModel[] {
      return state.unsubmittedDocuments;
    },
    submittedDocuments(state): VaultDataResponseModel[] {
      return state.submittedDocuments;
    },
    getVaultDocumentByID: (state) => (id): VaultDataResponseModel => {
      return state.unsubmittedDocuments.find((document) => {
        return document.vaultId === id;
      });
    },
  },
};

export default VAULT_STATE;
